import { styled } from "@mui/material";

import { Column } from "../layout";

export const List = styled(Column.withComponent("ul"))(({ theme }) => ({
  gap: theme.spacing(1),
  listStyle: "none",
  paddingInlineStart: "0",
  margin: 0,
}));
